if (!window.Eurus.loadedScript.has('tab-attention.js')) {
  window.Eurus.loadedScript.add('tab-attention.js');

  /* 2.3 PERFORMANS: Bu script yalnızca sekme başlığı animasyonu için gerekli;
     ilk boyama (FCP/LCP) için kritik DEĞİL. Profilde 196 ms uzun görev
     oluşturuyordu.

     KÖK NEDEN DÜZELTMESİ (2026-09-20): Alpine bileşeni `requestIdleCallback`
     İÇİNDE kaydediliyordu. Alpine, idle callback'ten ÖNCE başlatıldığında
     HTML'deki `x-data="xTabAttention"` çözülemiyor ve konsola
     "ReferenceError: xTabAttention is not defined" düşüyordu (Lighthouse
     errors-in-console + G3 kapısı ihlali).

     ÇÖZÜM: Alpine bileşeni SENKRON olarak (hemen) kaydedilir; yalnızca
     interval kurulumu (asıl maliyet) idle'a ertelenir. Davranış DEĞİŞMEZ. */
  var gTabAttentionRegister = function () {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xTabAttention', ({ message1, message2, delay }) => ({
        messages: (() => {
          if (message1 && !message2) return [message1];
          if (!message1 && message2) return [message2];
          return [message1, message2];
        })(),
        messageIndex: 0,
        intervalId: null,
        pageTitle: document.title,
        initTabAttention() {
          document.title = this.pageTitle;
          if (this.messages.length === 0) {
            return;
          }
          window.addEventListener('focus', this.handleStopTabAttention.bind(this));
          window.addEventListener('blur', this.handleStartTabAttention.bind(this));
        },
        
        handleStartTabAttention() {
          if (this.intervalId) return;
          this.intervalId = setInterval(() => {
            document.title = this.messages[this.messageIndex];
            this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          }, delay * 1000);
        },

        handleStopTabAttention() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          document.title = this.pageTitle;
        },
      }));
    });
  };

  // Alpine bileseni SENKRON kaydedilir — `x-data="xTabAttention"` hemen cozulur.
  gTabAttentionRegister();
}